import React, { useState } from "react";
import { withNamespaces } from "react-i18next";
import uuid from "uuid/v1";
import "../../../i18n";
import "../assets/scss/_replegmodal.scss";
import CustomButton from "./Button";
import Input from "./Input";
import Link from "./Link";
import Modal from "./Modal";
import SimpleInput from "./SimpleInput";

function AddRepLegModalContent({
  title,
  isModalShowing,
  setIsModalShowing,
  t,
  user,
}) {
  var contents;

  console.log(user);

  var newRepleg = {
    assina: 0,
    assinarPDA: 0,
    assinarProc: 0,
    bef: "false",
    cargo: "",
    createdDate: "",
    dataEmissaoComprovativo: null,
    dataExpiracao: null,
    dunResultadoPep: 0,
    estadoAssinatura: null,
    id: 0,
    idEntidade: 0,
    metodoAssinatura: null,
    modifiedDate: "",
    morada: null,
    moradaFiscal: null,
    nif: "",
    nome: "",
    numDocumento: null,
    numTelemovel: null,
    pdaLink: null,
    pep: null,
    pepDescricao: null,
    percentagem: "0.0",
    procNif: null,
    procNome: null,
    procPep: null,
    pvCreatedDate: null,
    pvDataExpiracao: null,
    pvDataNascimento: null,
    pvEstado: 0,
    pvMetodo: null,
    pvNacionalidade: null,
    pvNif: null,
    pvNome: null,
    pvNumDocumento: null,
    pvTipoDocumento: null,
    tipoDocumento: null,
  };

  const addButtonField = {
    type: "link",
    text: "Trocar de conta::easypay-button-link",
    cssclass: "",
    onclick: "",
    onmouseover: "center",
    align: "right",
    href: "javascript:disableForm(false);document.dados.toggleCodigoCertidao.value='addRepLeg';document.dados.op.value='3';document.dados.submit();",
    newwindow: "false",
    newwindowname: "",
    disabled: "false",
    even_field: "true",
  };

  const [inputArrayLenghts, setInputArrayLenghts] = useState([0, 0, 0]);
  const [replegName, setReplegName] = useState("");
  const [replegNif, setReplegNif] = useState("");
  const [replegCargo, setRepLegCargo] = useState("");

  function buildInputField(text, value) {
    return {
      value: "",
      obligatory: false,
      variable: value,
      maxlenght: 9,
      text: text,
    };
  }

  function handleBlurInputs(name, e) {
    console.log(e.target.value);
    if (name === "name") {
      setReplegName(e.target.value);
    } else if (name === "nif") {
      setReplegNif(e.target.value);
    } else {
      setRepLegCargo(e.target.value);
    }
  }

  function createBody() {
    return (
      <div className="easypay-repleg-modal-body-wrapper">
        <div style={{ width: "420px" }}>
          <Input
            field={buildInputField(
              t(`bpm.onboarding.backoffice.user.labelName`),
              "accordion_repleg_nome"
            )}
            key={"accordion_repleg_nome"}
            setInputArrayLenghts={setInputArrayLenghts}
            inputArrayLenghts={inputArrayLenghts}
            index={0}
            //handleOnBlur={(e) => handleBlurInputs("name", e)}
          ></Input>
        </div>
        <div style={{ width: "240px" }}>
          <Input
            field={buildInputField(
              t(`bpm.onboarding.backoffice.user.labelNIF`),
              "accordion_repleg_nif"
            )}
            key={"accordion_repleg_nif"}
            setInputArrayLenghts={setInputArrayLenghts}
            inputArrayLenghts={inputArrayLenghts}
            index={1}
            //handleOnBlur={(e) => handleBlurInputs("nif", e)}
          ></Input>
        </div>
        <div style={{ width: "420px" }}>
          <Input
            field={buildInputField(
              t(`bpm.onboarding.backoffice.user.labelRole`),
              "accordion_repleg_cargo"
            )}
            key={"accordion_repleg_cargo"}
            setInputArrayLenghts={setInputArrayLenghts}
            inputArrayLenghts={inputArrayLenghts}
            index={2}
            //handleOnBlur={(e) => handleBlurInputs("cargo", e)}
          ></Input>
        </div>
        <div
          className="easypay-repleg-modal-footer-wrapper"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "right",
            textAlign: "right",
          }}
        >
          <div
            className="easypay-repleg-modal-link-wrapper"
            style={{ paddingTop: "8px", textAlign: "right" }}
            onClick={(event) => {
              event.preventDefault();
              setIsModalShowing(false);
            }}
          >
            <Link
              text={t(`bpm.onboarding.backoffice.user.buttonCancel`)}
              disabledColored={false}
              disabled={false}
              link=""
              key={uuid()}
            />
          </div>
          <div
            className="easypay-repleg-modal-button-wrapper"
            style={{ paddingLeft: "25px" }}
          >
            <CustomButton
              text={t(`bpm.onboarding.backoffice.user.buttonAdd`)}
              variant={"easypay-button-primary"}
              onclick={eval(addButtonField.onclick)}
              key={uuid()}
              id={addButtonField.id}
              className="card-button"
              align={addButtonField.align}
              disabledColored={false}
              disabled={false}
              field={addButtonField}
            />
          </div>
        </div>
      </div>
    );
  }

  contents = {
    modalTitle: title,
    modalBody: createBody(),
  };

  return (
    <Modal
      className="easypay-modal"
      showModal={isModalShowing}
      setShowModal={setIsModalShowing}
      headerContent={contents.modalTitle}
      bodyContent={contents.modalBody}
      key={uuid()}
    ></Modal>
  );
}

export default withNamespaces()(AddRepLegModalContent);
